import { authConfig } from "../apiConfig";



export const get_technology_with_out_pagination = async () => {
  try {
    const response = await authConfig.post(`getTechnologyList`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const get_technology_with_pagination = async (data) => {
  try {
    const response = await authConfig.post(`getTechnologyList`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const get_technology_by_id = async (data) => {
  try {
    const response = await authConfig.post(`technologyViewByID`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const technology_creation = async (data) => {
  try {
    const response = await authConfig.post(`createTechnology`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const technology_update = async (data) => {
  try {
    const response = await authConfig.post(`updateTechnology`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};

export const technology_deletion = async (data) => {
  try {
    const response = await authConfig.post(`technologyDelete`, data, { headers: { "Content-Type": "multipart/form-data" } });
    return response;
  } catch (error) {
    throw error;
  }
};